import { useEffect, useState } from 'react'
import { report, reportListResponse, visit } from '../interfaces'
import ReportList from './components/ReportList'
import assets from './crudFunctions/assets'
import listFunction from './crudFunctions/listFunction'
import KindModal from './modals/KindModal'
import ReportModal from './modals/ReportModal'

const Reports = () => {
  const [reportList, setReportList] = useState<report[] | null>(null)
  const [kindList, setKindList] = useState<visit[] | null>(null)
  const [next, setNext] = useState<string | null>(null)
  const [previous, setPrevious] = useState<string | null>(null)
  const [singleReport, setSingleReport] = useState<report | null>(null)
  const [showReportModal, setShowReportModal] = useState<boolean>(false)
  const [showKindModal, setShowKindModal] = useState<boolean>(false)
  const reportEndpoint: string = 'report/list/'
  const listUrl: string = assets.apiUrl + reportEndpoint
  const kindEndpoint: string = 'visit/list'
  const kindListUrl: string = assets.apiUrl + kindEndpoint

  const nextPage = (): void => {
    listFunction(next!).then((response: reportListResponse) => {
      setReportList(response.results)
      setPrevious(response.previous)
      setNext(response.next)
    })
  }

  const previousPage = (): void => {
    listFunction(previous!).then((response: reportListResponse) => {
      setReportList(response.results)
      setPrevious(response.previous)
      setNext(response.next)
    })
  }
  useEffect(() => {
    listFunction(listUrl).then((response: reportListResponse) => {
      setReportList(response.results)
      setPrevious(response.previous)
      setNext(response.next)
    })
    listFunction(kindListUrl).then((response: visit[]) => {
      setKindList(response)
    })
  }, [listUrl, kindListUrl])
  return (
    <>
      <div className='grid'>
        <button
          className='bg-viper justify-self-center text-white text-3xl px-3 py-2 shadow-lg mt-3'
          onClick={() => setShowKindModal(true)}>
          Tipos de Reporte
        </button>
      </div>
      {showKindModal && (
        <KindModal kinds={kindList} setShowKindModal={setShowKindModal} />
      )}
      {showReportModal && (
        <ReportModal
          singleReport={singleReport}
          setShowReportModal={setShowReportModal}
        />
      )}

      {reportList ? (
        <ReportList
          reports={reportList}
          setSingleReport={setSingleReport}
          setShowReportModal={setShowReportModal}
        />
      ) : (
        <div className='loader animate-spin mx-auto mt-60'></div>
      )}
      <div className='grid grid-cols-2'>
        {previous ? (
          <button
            className='bg-viper justify-self-center text-white text-xl rounded-lg px-8 py-2 shadow-lg mt-3'
            onClick={previousPage}>
            Anterior
          </button>
        ) : (
          <button
            className='bg-gray-400 justify-self-center text-white text-xl rounded-lg px-8 py-2 shadow-lg mt-3'
            disabled>
            Anterior
          </button>
        )}

        {next ? (
          <button
            className='bg-viper justify-self-center  text-white text-xl rounded-lg px-8 py-2 shadow-lg mt-3 ml-7'
            onClick={nextPage}>
            <span>Siguiente</span>
          </button>
        ) : (
          <button
            className='bg-gray-400 justify-self-center  text-white text-xl rounded-lg px-8 py-2 shadow-lg mt-3 ml-7'
            disabled>
            <span>Siguiente</span>
          </button>
        )}
      </div>
    </>
  )
}
export default Reports
